/* unplugin-vue-components disabled */import { render } from "./socket.vue?vue&type=template&id=0bd604f8"
import script from "./socket.vue?vue&type=script&lang=js"
export * from "./socket.vue?vue&type=script&lang=js"

import exportComponent from "D:\\un-app\\zsmy_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__